import "../../../styles/src/05-components/blog-roll/style.scss";

// Quickmenu
import QuickMenu from "quickmenu";

document.addEventListener("DOMContentLoaded", () => {
    /**
     * If a date filter is present, grab those values. If not, set the filter
     * date to today.
     */

    // Build today's date
    let todayString =
        String(new Date().getFullYear()) +
        "-" +
        String(new Date().getMonth() + 1).padStart(2, "0") +
        "-" +
        String(new Date().getDate()).padStart(2, "0");

    let hasDates = "";
    let startDate = "";
    let endDate = "";
    if (
      document.querySelector("#startDate") &&
      document.querySelector("#endDate")
    ) {
      hasDates = true;
      startDate = document.querySelector("#startDate").value;
      endDate = document.querySelector("#endDate").value;
    } else {
      hasDates = false;
      let today = new Date().toISOString().slice(0, 10);
      // If there is a filterDate, set it
      if (
        document.querySelector("#filterDate") &&
        document.querySelector("#filterDate") !== null
      ) {
        document.querySelector("#filterDate").value = today;
      }
    }

    // Post category archive controller
    if (document.querySelector(".blog-roll")) {
        new QuickMenu();

        let archiveSelect = document.getElementById("blog-roll-archive-select");
        const archiveButton = document.getElementById("blog-roll-archive");
        archiveButton.addEventListener("click", function (event) {
            event.preventDefault();

            // Ignore empty values
            if (archiveSelect.value == "") {
                return;
            } else {
                window.location.href = archiveSelect.value;
            }
        });

        // Get query data for initial posts
        let filterCategories = document.querySelector(".blog-roll__wrapper").dataset.categories;
        let postArray = [];
        let fetchUrl = window.location.protocol + "//" + window.location.hostname;
        if (window.location.port !== "") {
            fetchUrl += ":" + window.location.port;
        }
        fetchUrl += "/wp-json/wp/v2/posts?more_per_page=9999";
        if (filterCategories != "") {
            fetchUrl += "&categories=" + filterCategories;
        }
        fetch(fetchUrl + "&_fields=id")
            .then((response) => response.json())
            .then((posts) => {
                for (const post in posts) {
                    postArray.push(posts[post].id);
                }
            });

        // Set the results container and initial values
        let resultsContainer = document.querySelector(".blog-roll__link-container");
        let resultsLoader = document.querySelector(".blog-roll__loader");
        if (resultsLoader != null) {
            resultsLoader.style = "";
        }
        const initialResults = resultsContainer.innerHTML;
        let filterDate = "";
        if (hasDates == false) {
            filterDate = document.getElementById("filterDate").value;
        }
        let filterKeyword = document.getElementById("filterKeyword").value;

        // Grab the default post image
        const defaultThumbnail = document.querySelector(".blog-roll__wrapper").dataset.thumbnail;

        // Form to control filter results
        const filterButton = document.getElementById("filterButton");
        filterButton.addEventListener("click", function (event) {
            event.preventDefault();

            // Reset fetch URL
            fetchUrl = window.location.protocol + "//" + window.location.hostname;
            if (window.location.port !== "") {
                fetchUrl += ":" + window.location.port;
            }
            fetchUrl += "/wp-json/wp/v2/posts?per_page=5";
            if (filterCategories != "") {
                fetchUrl += "&categories=" + filterCategories;
            }

            if (hasDates === false) {
                filterDate = document.getElementById("filterDate").value;
            }
            filterKeyword = document.getElementById("filterKeyword").value;

            // Fetch posts from the data provided
            if (hasDates === true) {
                fetchUrl += "&order=desc&after=" + startDate + "T00:00:00&before=" + endDate + "T00:00:00";
                if (filterKeyword !== "") {
                    fetchUrl += "&search=" + filterKeyword;
                }
            } else if (hasDates === false && filterDate !== "") {
                fetchUrl += "&order=desc&before=" + filterDate + "T00:00:00";
                if (filterKeyword !== "") {
                    fetchUrl += "&search=" + filterKeyword;
                }
            } else {
                if (filterKeyword !== "") {
                    fetchUrl += "&order=desc&search=" + filterKeyword;
                }
            }
            fetchUrl += "&orderby=date&_fields=id,link,date,title,excerpt,categories,featured_media";

            // If the keyword is empty and the date is either empty or set to today, skip the rest
            if (filterKeyword == "" && (filterDate == "" || filterDate == todayString)) {
                resultsContainer.innerHTML = initialResults;
            } else {
                // Build the results list
                fetch(fetchUrl)
                    .then((response) => response.json())
                    .then((posts) => {
                        if (resultsContainer != null) {
                            if (resultsContainer.classList) {
                                resultsContainer.classList.add("is-loading");
                                if (resultsLoader != null) {
                                    resultsLoader.classList.add("is-visible");
                                }
                            }
                            resultsContainer.innerHTML = "";
                            if (posts.length > 0) {
                                posts.forEach((post) => {
                                    setUpPost(post, postArray, resultsContainer, defaultThumbnail);
                                });
                            } else {
                                resultsContainer.innerHTML += `<p>We could not find any posts with that keyword.</p>`;
                                resultsLoader.classList.remove("is-visible");
                            }
                        }
                    });
            }
        });

        // Results view controller
        const viewIcons = document.querySelectorAll(".blog-roll__view-icon");
        viewIcons.forEach(function (element) {
            element.addEventListener("click", function () {
                let modifier = element.dataset.value;

                // Ignore if the value is already applied
                if (resultsContainer.dataset.layout == modifier) {
                    return;
                } else {
                    resultsContainer.dataset.layout = modifier;
                    resultsContainer.className = "blog-roll__link-container blog-roll__link-container--" + modifier;
                }
            });
        });
    }
});

/**
 * Sets up blog roll data for a post
 * @param string post
 */
let setUpPost = async (post, postPool, container, defaultThumbnail) => {
    // Check if any posts are in the pool. If not, skip it.
    if (post == undefined) {
        return;
    }

    // Check if the post is in the pool. If not, skip it.
    if (postPool.indexOf(post.id) == -1) {
        return;
    }

    // Set up fetch URL
    let fetchUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "") {
        fetchUrl += ":" + window.location.port;
    }

    // Set up fetches
    let fetchCats = await fetch(fetchUrl + "/wp-json/wp/v2/categories" + "?include=" + post.categories.join(", "));
    let categoriesJSON = await fetchCats.json();
    let fetchMedia;
    if (post.featured_media == 0) {
        fetchMedia = await fetch(fetchUrl + "/wp-json/wp/v2/media/" + defaultThumbnail);
    } else {
        fetchMedia = await fetch(fetchUrl + "/wp-json/wp/v2/media/" + post.featured_media);
    }
    let featuredImageJSON = await fetchMedia.json();

    Promise.all([categoriesJSON, featuredImageJSON])
        .then((values) => {
            // Grab values from post
            let link = post.link;
            let date = new Date(post.date).toLocaleDateString("en-us", { year: "numeric", month: "long", day: "numeric" });
            let title = post.title.rendered;
            let excerpt = post.excerpt.rendered;

            // Set up categories
            let categories = [];
            values[0].forEach((cat) => {
                let category = new Object();
                category.url = cat.link;
                category.name = cat.name;
                categories.push(category);
            });
            let categoryCode = '<ul class="blog-roll__link-categories">';
            categories.forEach((category) => {
                categoryCode += `<li><a href="${category.url}">${category.name}</a></li>\n`;
            });
            categoryCode += "</ul>";

            // Set up media
            let featuredImage = new Object();
            featuredImage.alt = values[1].alt_text ? values[1].alt_text : title;
            featuredImage.src = typeof values[1].media_details != "undefined" ? values[1].media_details.sizes["480w"].source_url : defaultThumbnail;

            container.innerHTML += `<div class="blog-roll__link-item"><a class="blog-roll__link blog-roll__link--image" href="${link}"><img class="blog-roll__link-image" src="${featuredImage.src}" alt="${featuredImage.alt}" /></a><div class="blog-roll__link-content">${categoryCode}<a class="blog-roll__link blog-roll__link--masthead" href="${link}"><h3 class="blog-roll__link-heading">${title}</h3><span class="blog-roll__link-date">${date}</span></a><div class="blog-roll__link-body">${excerpt}</div></div></div>`;
            document.querySelector(".blog-roll__loader").classList.remove("is-visible");
        })
		// eslint-disable-next-line no-unused-vars
        .catch((error) => {
            // eslint-disable-next-line no-console
            // console.error('Error:', error);
        });
};
